import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown } from 'semantic-ui-react';
import './DocumentsContainer.less';

const initialState = { windowWidth: 0 }

const options = [
    {
        key: 'section_0',
        text: 'The Syndafy Platform Connects Vendors and Clients',
        value: '0',
    },

    {
        key: 'section_1',
        text: 'User Vetting and User Representations and Warrantiesn',
        value: '1',
    },
    {
        key: 'section_2',
        text: 'Contract between Clients and Vendors',
        value: '2',
    },
    {
        key: 'section_3',
        text: 'Billing and Payment',
        value: '3',
    },

    {
        key: 'section_4',
        text: 'Promotional Codes',
        value: '4',
    },
    {
        key: 'section_5',
        text: 'Public Areas; Acceptable Use',
        value: '5',
    },
    {
        key: 'section_6',
        text: 'Mobile App Updates and Upgrades',
        value: '6',
    },
    {
        key: 'section_7',
        text: 'Termination and Suspension',
        value: '7',
    },
    {
        key: 'section_8',
        text: 'Account, Password, Security, and Mobile Phone Use',
        value: '8',
    },
    {
        key: 'section_9',
        text: 'User Generated Content',
        value: '9',
    },
    {
        key: 'section_10',
        text: 'Links to Third-Party Websites',
        value: '10',
    },
    {
        key: 'section_11',
        text: 'Worker Classification and Withholdings',
        value: '11',
    },
    {
        key: 'section_12',
        text: 'Intellectual Property Rights',
        value: '12',
    },

    {
        key: 'section_13',
        text: 'Copyright Complaints and Copyright Agent',
        value: '13',
    },

    {
        key: 'section_14',
        text: 'Confidential Information',
        value: '14',
    },

    {
        key: 'section_15',
        text: 'Disclaimer of Warranties',
        value: '15',
    },
    {
        key: 'section_16',
        text: 'Indemnification',
        value: '16',
    },
    {
        key: 'section_17',
        text: 'Dispute Resolution – Arbitration & Class Action Waiver (U.S. Users)',
        value: '17',
    },
    {
        key: 'section_18',
        text: 'Governing Law',
        value: '18',
    },
    {
        key: 'section_19',
        text: 'No Agency; No Employment',
        value: '19',
    },
    {
        key: 'section_20',
        text: 'General Provisions',
        value: '20',
    },
    {
        key: 'section_21',
        text: 'Licensing',
        value: '21',
    },
    {
        key: 'section_22',
        text: 'Changes to this Agreement and the Syndafy Platform',
        value: '22',
    },
    {
        key: 'section_23',
        text: 'No Rights of Third Parties',
        value: '23',
    },
    {
        key: 'section_24',
        text: 'Notices and Consent to Receive Notices Electronically',
        value: '24',
    },
];
class TermsOfUseContainer extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        for (let i = 0; i < 25; i++) {
            this['section_' + i] = createRef();
            this['link_' + i] = createRef();
        }
        this.sectionOffsetTop = [];
        this.section = 0;

    }

    onLinkClick = (event) => {
        const section = event.target.attributes.value.value;

        this[`section_${section}`].current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });

    }

    onItemClick = (event, data) => {

        const section = data.value;

        this[`section_${section}`].current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });

    }

    componentDidMount() {
        window.addEventListener('resize', this.updateWindowDimensions);
        this.updateWindowDimensions();
        /*for (let i = 0; i < 13; i++) {
            if (i > 0) {
                this.sectionOffsetTop[i - 1].max = this[`section_${i}`].current.offsetTop - 1;
            }

            this.sectionOffsetTop.push({ min: this[`section_${i}`].current.offsetTop });

            if (i == 12) {
                this.sectionOffsetTop[i].max = this.sectionOffsetTop[i].min + 1000;
            }

        }*/

        
    }

    handleScroll = (event) => {


        if (event.target.scrollTop <= this.sectionOffsetTop[0].min) {

            this[`link_0`].current.classList.add("active");
            if (this.section != 0)
                this[`link_${this.section}`].current.classList.remove("active");
            this.section = 0;
        }
        else {
            for (let i = 1; i < 13; i++) {
                const currentScrollTop = event.target.scrollTop + 84;
                if (currentScrollTop >= this.sectionOffsetTop[i].min && currentScrollTop <= this.sectionOffsetTop[i].max) {
                    if (this.section != i) {
                        this[`link_${i}`].current.classList.add("active");

                        this[`link_${this.section}`].current.classList.remove("active");


                        this.section = i;
                    }


                }
            }
        }



    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });

    }
    render() {
        return (
            <div className="privacy-policy-main-container">
                {this.state.windowWidth < 768 &&
                    <div className="dropdown-container">
                        <Dropdown placeholder="Select section" fluid selection options={options} onChange={this.onItemClick}>

                        </Dropdown>
                    </div>
                }
                {this.state.windowWidth >= 768 && <div className="links">
                    {
                        options.map((option, index) => {
                            return <div key={index} className="link" value={`${option.value}`} ref={this[`link_${option.value}`]} onClick={this.onLinkClick}>
                                {option.text}
                            </div>
                        })
                    }

                </div>}
                <div className="content" onScroll={this.handleScroll}>
                    <div className="main-header">
                        Syndafy&nbsp;<div className="emphasize">Terms of Service</div>
                    </div>

                    <div className="big-heading">
                        Product Name: ServiceGrace
                    </div>
                    <div className="item-text">These Terms of Service constitute a legally binding agreement between you and Syndafy, Inc.
    (<b>“Company”</b> or <b>“Syndafy”</b>) governing your use of the Syndafy Platform (as defined below),
    Company’s website (https://www.Syndafy.com or the “Site”) and mobile applications (the
    <b>“Apps”</b>). The Syndafy Platform and related services provided by Company, the Site, and Apps,
    including without limitation communications and information (whether in writing, orally, or
    otherwise howsoever) provided by Company to potential and actual Vendors and Clients (both as
    defined at Section 􀀀1) in relation to the services, together are hereinafter collectively referred to
    as the <b>“Syndafy Platform.”</b><br /><br />

    Any personal data you submit to the Syndafy Platform or which we collect about you is governed
by our Privacy Policy (<b>“Privacy Policy”</b>). You acknowledge that by using the Syndafy Platform
you have reviewed the Privacy Policy. <br /><br />
Your use of the Syndafy Platform constitutes your acceptance of and agreement to all of the terms
                    and conditions in these Terms of Service and the Privacy Policy, and any future amendments and
                    additions to this Agreement (as defined below) as we may publish from time to time. The Privacy
                    Policy is incorporated by reference into these Terms of Service and together form and are
hereinafter referred to as this <b>“Agreement”</b>.
                        <br /><br />
                        <div className="highlighted-para"><span className="alert">PLEASE NOTE:</span> THIS AGREEMENT GOVERNS HOW DISPUTES BETWEEN YOU AND
                        SYNDAFY CAN BE RESOLVED. IT CONTAINS A BINDING AND FINAL ARBITRATION
                        PROVISION AND CLASS ACTION WAIVER (SECTION 􀀀18). PLEASE READ
                        CAREFULLY AS IT AFFECTS YOUR LEGAL RIGHTS, INCLUDING, IF APPLICABLE,
                        YOUR RIGHT TO OPT OUT OF ARBITRATION.
                    <br />
                    IN ADDITION, BY ENTERING INTO THIS AGREEMENT, YOU EXPRESSLY
                    ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTAND AND AGREE, WITHOUT
                    LIMITATION OR QUALIFICATION, TO BE BOUND BY THIS AGREEMENT (INCLUDING
                    THE DISPUTE RESOLUTION AND ARBITRATION PROVISIONS IN SECTION 􀀀18) AND
                    YOU ACCEPT ALL OF ITS TERMS.
                    <br /><br /><br />
                            <span className="alert">IF YOU DO NOT AGREE TO BE BOUND BY THIS AGREEMENT, YOU MAY NOT USE
OR ACCESS THE SYNDAFY PLATFORM.</span>

                        </div>
                        <br />
                        <div>
                            Your use of the Syndafy Platform constitutes your acceptance of and agreement to all of the terms
                            and conditions in the Terms of Service and the Privacy Policy.
                        </div>
                        <br />
                        <div>
                            You must be 21 years old (for U.S. based users) or at least the legally required age in the
                            jurisdiction in which you reside, and otherwise capable of entering into binding contracts, in order
                            to use or access the Syndafy Platform. If you are under 21 years old (for U.S. based users) or the
                            age of majority in your jurisdiction, then you may not use or access the Syndafy Platform. Children
                            under 13 years old are prohibited from accessing the Syndafy Platform or otherwise providing any
                            personal information to Syndafy.
</div>
                        <br />
                        <div>
                            <b>A few highlights of these Terms of Service include:</b>
                            <ul className="unordered">
                                <li>
                                    Your agreement that the Syndafy Platform is provided “as is” and without warranty
                                    (Section 16).
  </li>
                                <li>
                                    Your agreement that Company has no liability regarding the Syndafy Platform or the
                                    performance of Services (as defined below at Section 1) (Section 16).
  </li>
                                <li>
                                    Your acknowledgment and agreement that Clients, and not Syndafy, scope, supervise,
                                    direct, control, and monitor a Vendor’s work and the Services (Section 1).
  </li>
                                <li>
                                    Your acknowledgement and agreement that Clients are solely responsible for determining
                                    if the Vendor they hire is qualified to perform the Service at hand.
  </li>
                                <li>
                                    Your acknowledgement and agreement that Vendors are independent contractors of Clients
                                    and not employees, independent contractors or service providers of Syndafy (Sections 1
                                    and 12)
  </li>
                                <li>
                                    Your consent to release Company from liability based on claims between Users (Section
                                    2), in respect of Vendor claims (Section 12) and generally (Section 16).
  </li>
                                <li>
                                    Your agreement to indemnify Company from claims due to your use or inability to use the
                                    Syndafy Platform or content submitted from your account to the Syndafy Platform (Section
                                    17).
  </li>
                                <li>
                                    Your consent to submit any claims against Company to binding arbitration, and on an
                                    individual basis only, to the extent permissible by law (Section 18).
  </li>
                            </ul>


                        </div>

                    </div>

                    <div className="small-heading" ref={this[`section_0`]}>
                        1. The Syndafy Platform Connects Vendors and Clients
                    </div>
                    <div className="item-text">
                        The Syndafy Platform is a web-based communications platform which enables connections
                        between Clients and Vendors. “Clients” are individuals and/or businesses seeking to obtain
                        services (“Services”) from Vendors and are therefore clients of Vendors, and “Vendors” are
                        individuals and/or businesses seeking to perform Services for Clients. Clients and Vendors
                        together are hereinafter referred to as “Users.” If you agree on the terms of a Service with another
                        User, you and such other User form a Service Agreement directly between the two of you as set
                        forth in more detail in Section 3 below.
<br />
                        <br />
VENDORS ARE INDEPENDENT CONTRACTORS OF CLIENTS AND NOT EMPLOYEES,
PARTNERS, REPRESENTATIVES, AGENTS, JOINT VENTURERS, INDEPENDENT
CONTRACTORS OR FRANCHISEES OF COMPANY. COMPANY DOES NOT PERFORM
SERVICES AND DOES NOT EMPLOY INDIVIDUALS TO PERFORM SERVICES. USERS
HEREBY ACKNOWLEDGE THAT COMPANY DOES NOT SUPERVISE, DIRECT,
CONTROL OR MONITOR A VENDOR’S WORK AND EXPRESSLY DISCLAIMS ANY
RESPONSIBILITY AND LIABILITY FOR THE WORK PERFORMED AND THE SERVICES
IN ANY MANNER, INCLUDING BUT NOT LIMITED TO A WARRANTY OR CONDITION
OF GOOD AND WORKMANLIKE SERVICES, WARRANTY OR CONDITION OF
QUALITY OR FITNESS FOR A PARTICULAR PURPOSE, OR COMPLIANCE WITH ANY
LAW, REGULATION, OR CODE.

<br />
                        <br />
The Syndafy Platform only enables connections between Users for the fulfillment of Services.
Company is not responsible for the performance or communications of Users, nor does it have
control over the quality, timing, legality, failure to provide, or any other aspect whatsoever of
Services, Vendors, Clients, nor of the integrity, responsibility, competence, qualifications, or any
of the actions or omissions whatsoever of any Users, or of any ratings provided by Users with
respect to each other. Company makes no warranties or representations about the suitability,
reliability, timeliness, or accuracy of the Services requested or services provided by, or the
communications of or between, Users identified through the Syndafy Platform, whether in public,
private, or offline interactions or otherwise howsoever.

                    </div>

                    <div className="small-heading" ref={this[`section_1`]}>
                        2. User Vetting and User Representations and Warranties
                    </div>
                    <div className="item-text">
                        <b>User Vetting</b>
                        <br />
                        <br />
In Company’s sole discretion, Users may be subject to a vetting process before they can register
for and during their use of the Syndafy Platform, including but not limited to a verification of
identity, using third party services as appropriate (“Identity Checks”). Although Company may
perform Identity Checks, Company is not required to do so and cannot confirm that each User is
who they claim to be. Company cannot and does not assume any responsibility for the accuracy or
reliability of Identity Check information or any information provided through the Syndafy
Platform.
<br />
                        <br />
When interacting with other Users, you should exercise caution and common sense to protect your
personal safety, data, and property, just as you would when interacting with other persons whom
you don’t know. Syndafy will not be liable for any false or misleading statements made by Users
of the Syndafy Platform. NEITHER SYNDAFY NOR ITS PARENTS, AFFILIATES OR
LICENSORS, INCLUDING THEIR RESPECTIVE DIRECTORS, OFFICERS,
SHAREHOLDERS, AGENTS, INVESTORS, SUBSIDIARIES, ATTORNEYS,
REPRESENTATIVES, INSURERS, EMPLOYEES, SUCCESSORS AND ASSIGNS
(HEREINAFTER REFERRED TO COLLECTIVELY AS “SYNDAFY AND AFFILIATES”)
IS RESPONSIBLE FOR THE CONDUCT, ACTS, OR OMISSIONS, WHETHER ONLINE OR
OFFLINE, OF ANY USER OF THE SYNDAFY PLATFORM AND YOU HEREBY RELEASE
SYNDAFY AND AFFILIATES FROM ANY AND ALL LIABILITY, CLAIMS, DEMANDS,
OR DAMAGES OF EVERY KIND AND NATURE, KNOWN AND UNKNOWN, SUSPECTED
AND UNSUSPECTED, DISCLOSED AND UNDISCLOSED, ARISING OUT OF OR IN ANY
WAY CONNECTED WITH THE SYNDAFY PLATFORM.
<br />
                        <br />
                        <b>User Representations and Warranties</b>
                        <br />
                        <br />
You represent and warrant that: (1) you are 21 years of age or older or are at least of the legally
required age in the jurisdiction in which you reside, and are otherwise capable of entering into
binding contracts, and (2) you have the right, authority and capacity to enter into this Agreement
and to abide by the terms and conditions of this Agreement, and that you will so abide. Where you
enter into this Agreement on behalf of a company or other organization, you represent and warrant
that you have authority to act on behalf of that entity and to bind that entity to this Agreement.
<br />
                        <br />
You further represent and warrant that you have read, understand, and agree to be bound by these
Terms of Service and the Privacy Policy in order to access and use the Syndafy Platform. You
hereby warrant and represent that you will respect the privacy (including without limitation
private, family and home life), property and data protection rights of Users and that you will not
record (whether video or audio or otherwise) any Service or any interaction by or with any User
and/or Company in connection with the Syndafy Platform without the prior written consent of
Company and/or the relevant User, as applicable. You further represent and warrant that you will
fulfill the commitments you make to other Users, including paying/receiving payment through the
Syndafy Platform using the PSP, if available (as defined below) or paying directly to Vendor as
agreed upon between Vendor and Client, performing the Service(s) agreed upon as between the
Vendor and Client, communicating clearly and promptly through the chat thread and/or responding
to invitations promptly, being present and/or available at the time you agree upon with your Vendor
or Client as the case may be, and only utilizing the third party payment processing system specified
or approved by us to make or receive payment for services provided through the Syndafy Platform,
if available (the <b>“PSP”</b>) . You also represent and warrant that you will act professionally and
responsibly in your interactions with other Users. You further represent and warrant that when
using or accessing the Syndafy Platform, you will act in accordance with any applicable local,
state, provincial, national, or international law or custom and in good faith.
<br />
                        <br />
You hereby warrant and represent that, other than as fully and promptly disclosed to Company as
set forth below, you do not have any motivation, status, or interest which Company may reasonably
wish to know about in connection with the Syndafy Platform, including without limitation, if you
are using or will or intend to use the Syndafy Platform for any journalistic, investigative, or
unlawful purpose. You hereby warrant and represent that you will promptly disclose to Company
in writing any such motivation, status or interest, whether existing prior to registration or as arises
during your use of the Syndafy Platform.
<br />
                        <br />
Vendors additionally represent and warrant that you will provide timely, high-quality services to
your Clients, you will only offer and provide services for which you have the necessary skills and
expertise, and you will provide the services safely and in accordance with all applicable laws, and
that you have the legal right to work in the country in which you are performing Services. You
must provide the Services precisely based on the definition and requirements of such particular
services as defined by Syndafy. As an example, Syndafy could define an oil change service to
mean five quarts of oil, a new oil filter and fluids top off. You must perform the Service based on
Syndafy’s definition and requirements. You must carry your own general liability insurance and
workers comp insurance. Syndafy can request a copy of your Certificate of Insurance at any time
and you must provide a copy to Syndafy within 48 hours.
                    </div>





                    <div className="small-heading" ref={this[`section_2`]}>
                        3. Contract between Clients and Vendors
                    </div>
                    <div className="item-text">
                        You acknowledge and agree that a legally binding contract (the “Service Agreement”) is formed
                        when you agree on the terms of a Service with another User. The terms of the Service Agreement
                        include the terms set forth in this Section 3, the engagement terms proposed and accepted on the
                        Syndafy Platform, and any other contractual terms accepted by both the Vendor and their Client
                        to the extent such terms do not conflict with the terms in this Agreement, including this Section 3,
                        and do not expand Company’s obligations or restrict Company’s rights under this Agreement. You
                        agree that You will honor the price and Service as quoted on the Syndafy Platform. You agree
                        that Company is not a party to any Service Agreement and the formation of a Service Agreement
                        will not, under any circumstance, create an employment or other service relationship between
                        Company and the Vendor (or Assistants (as defined below)), nor will it create an employment
                        relationship between the Client and the Vendor (or Assistants (as defined below)). Company’s role
                        is restricted solely to introducing Client to the Vendor and acting as a limited payment collection
                        agent for the Vendor, if applicable, to facilitate payment on behalf of the Vendor through the
                        Syndafy Platform using the PSP in respect of Services they perform. In acting as the limited
                        payment collection agent for particular Services on the Syndafy Platform, Syndafy disclaims any
                        other agency or authority to act on behalf of the Vendor, and assumes no liability or responsibility
                        for any acts or omissions of the Vendor, either within or outside of the Syndafy Platform.
<br />
                        <br />
Where approved in advance by the Client, the Vendor is not obligated to personally perform the
Service. Before any Service services are performed by any assistants, helpers, subcontractors or
other personnel engaged by the Vendor (collectively <b>“Assistants”</b>). The Vendor assumes full and
sole responsibility for the acts and omissions of such Assistants, including without limitation the
payment of all compensation, benefits and expenses of Assistants, if any, and for all required and
applicable income tax withholdings as to the Vendor and all persons engaged by the Vendor in the
performance of the Service services.
<br />
                        <br />
While using the Syndafy Platform, Clients, in their sole discretion, determine whether they will be
present or not when a Service is performed and/or completed. Clients who elect not to be present
when a Service is performed and/or completed agree that if someone other than them (i.e. spouse,
roommate, friend, etcetera) is present when the Service is performed, they are appointing that
person as their agent (“Client’s Agent”) and the Vendor may take and follow direction from the
Client’s Agent as if such direction was given from the Client him or herself.
<br />
                        <br />
The Client shall pay their Vendor directly for completed Service services or through the PSP as
indicated on the Syndafy Platform, if available, at the rates agreed to by the parties in the Service
Agreement. Each User agrees to comply with the Service Agreement and this Agreement during
the engagement, performance and completion of a Service. Both Users agree to notify Company
of any disputes prior to negotiation of or filing of any claims and to negotiate any dispute
informally via Company representatives for at least thirty (30) days before initiating any
proceeding. Syndafy reserves the right to suspend or terminate any account or Service pending the
resolution of any dispute.
                    </div>



                    <div className="small-heading" ref={this[`section_3`]}>
                        4. Billing and Payment
                    </div>
                    <div className="item-text">
                        Users of the Syndafy Platform contract for Services directly with other Users. Company will not
                        be a party to any contracts for Services. Payment for Service services is made directly from the
                        Client to the Vendor. In some cases, payment may be made through the Syndafy Platform via the
                        PSP, and not by Company. Company is not obligated to pay Vendor for Client’s failure to pay for
                        services or Vendor’s failure to refund payment to Client.
<br />
                        <br />
Vendors may be required to register with the PSP, agree to terms of service of the PSP, and go
through a vetting process at the request of the PSP to set up their account with the PSP (the <b>“PSP
Services Agreement”</b>). By accepting these Terms of Service, each Vendor agrees that they have
downloaded or printed, and reviewed and agreed to, the PSP Services Agreement. Please note that
Syndafy is not a party to the PSP Services Agreement and that you, the PSP and any other parties
listed in the PSP Services Agreement are the parties to the PSP Services Agreement and that
Syndafy has no obligations, responsibility or liability to any Vendor or other party under the PSP
Services Agreement.
<br />
                        <br />
Company reserves the right (but not the obligation), in its sole discretion, upon request from Client
or Vendor, or upon notice of any potential fraud, unauthorized charges or other misuse of the
Syndafy Platform, to (i) place on hold any Service Payment, out of pocket expenses, and/or tip or
gratuity (if applicable) or (ii) refund or provide credits, or arrange for the PSP to do so.
<br />
                        <br />
Users of the Syndafy Platform will be liable for any taxes required to be paid on the Services
provided under the Agreement.
                    </div>


                    <div className="small-heading" ref={this[`section_4`]}>
                        5. Promotional Codes
                    </div>
                    <div className="item-text">
                        Company may from time to time provide certain promotional opportunities to Users. All such
                        promotions will be run at the sole discretion of Company, and can be activated, modified, or
                        removed at any time by Company without advance notification. The liability of any of Company’s
                        corporate partners pursuant to such promotional opportunities shall be limited pursuant to Section
                        16 of these Terms of Service.
<br />
                        <br />
Company promotional codes (<b>“Promo Codes”</b>) may be available and can be used to pay Service
Payments and Company service charges and platform fees in part or in full, but may not be used
to pay for reimbursement of out of pocket expenses or tips associated with a Service provided
through the Syndafy Platform.
<br />
                        <br />
Promo Codes are an offer by Company to reduce the amount a Client has to pay in relation to a
Service Payment, service fee, and/or platform fee. Promo Codes will not affect the amount of the
Service Payment a Vendor ultimately receives. The use or application of any Promo Code is solely
intended as a promotional initiative and does not in any way create a relationship or engagement
between Company or the Vendor or represent wages, fees or other amounts paid to the Vendor by
Company. You agree that you will use Promo Codes in accordance with the terms of the Promo
Code. Company reserves the right to withhold or deduct credits or other features or benefits
obtained through the use of a Promo Code by you or any other User in the event that Company
determines or believes that the use or redemption of a Promo Code was in error, fraudulent, illegal,
or in violation of the applicable Promo Code terms or this Agreement.
                    </div>



                    <div className="small-heading" ref={this[`section_5`]}>
                        6. Public Areas; Acceptable Use
                    </div>
                    <div className="item-text">
                        The Syndafy Platform may contain profiles, email systems, blogs, message boards, reviews,
                        ratings, applications, job postings, chat areas, news groups, forums, communities and/or other
message or communication facilities (<b>“Public Areas”</b>) that allow Users to communicate with other
Users. You may only use such community areas to send and receive messages and materials that
are relevant and proper to the applicable forum. For the safety and integrity of the Syndafy
Platform, you should not share your personal contact information with other Users.
<br />
                        <br />
  Without limitation, while using the Syndafy Platform, you may not:
  <br />
                        <br />
                        <ul className="unordered">
                            <li>
                                Defame, abuse, harass, stalk, threaten, intimidate, misrepresent, mislead or otherwise
                                violate the legal rights (such as, but not limited to, rights of privacy, confidentiality,
                                reputation, and publicity) of others, including Users and Syndafy staff, or use information
                                learned from the Syndafy Platform or during the performance of Services to otherwise
                                defame, abuse, harass, stalk, threaten, intimidate, misrepresent, mislead, or otherwise
                                violate the legal rights of any other User or Company staff;
    </li>
                            <li>
                                Advertise or offer to sell any goods or services for any commercial purpose through the
                                Syndafy Platform which are not relevant to the Service services offered through the
                                Syndafy Platform;
    </li>
                            <li>
                                Post or upload any content to which you have not obtained any necessary rights or
                                permissions to use accordingly;
    </li>
                            <li>
                                Remove or alter, visually or otherwise, any copyrights, trademarks or proprietary marks or
                                rights owned by Syndafy and Affiliates;
    </li>
                            <li>
                                Upload files that contain software or other material that violates the intellectual property
                                rights (or rights of privacy or publicity) of any User, third party, or Company;
    </li>
                            <li>
                                Publish, post, upload, distribute or disseminate any profane, defamatory, infringing,
                                obscene or unlawful topic, name, material or information on the Syndafy Platform;
    </li>
                            <li>
                                Use the Syndafy Platform for any unauthorized purpose, including, but not limited to
                                posting or completing a Service in violation of local, state, national, or international law;
    </li>
                            <li>
                                Upload files that contain viruses, Trojan horses, corrupted files, or any other similar
                                software that may damage the operation of another’s computer;
    </li>
                            <li>
                                Post or complete a Service requiring a User to (i) purchase or obtain money orders (ii)
                                provide ridesharing or other peer to peer transportation services, (iii) post ratings or reviews
                                on any third party website in breach of such third party website’s terms of use, or (iv)
                                otherwise engage in activity that is illegal or deemed dangerous, harmful or otherwise
                                inappropriate by Company in its sole discretion;
    </li>
                            <li>
                                Conduct or forward surveys, contests, pyramid schemes, or chain letters;
    </li>
                            <li>
                                Impersonate another person or a User or allow any other person or entity to use your
                                identification to post or view comments;
    </li>
                            <li>
                                Post the same Service repeatedly (“Spamming”) – Spamming is strictly prohibited;
    </li>
                            <li>
                                Download any file posted by another User that a User knows, or reasonably should know,
                                cannot be legally distributed through the Syndafy Platform;
    </li>
                            <li>Restrict or inhibit any other User from using and enjoying the Public Areas;</li>
                            <li>Imply or state that any statements you make are endorsed by Syndafy, without the prior
written consent of Syndafy;</li>
                            <li>Use a robot, spider, manual, meta tag, “hidden text,” agent, robot, script, and/or automatic
                            processes or devices to data-mine, data-crawl, scrape, collect, mine, republish, redistribute,
                            transmit, sell, license, download, manage or index the Syndafy Platform, or the electronic
addresses or personal information of others, in any manner;</li>
                            <li>Frame or utilize framing techniques to enclose the Syndafy Platform or any portion thereof;</li>
                            <li>Hack or interfere with the Syndafy Platform, its servers or any connected networks;</li>
                            <li>Adapt, alter, license, sublicense or translate the Syndafy Platform for your own personal or
commercial use;</li>
                            <li>Upload content to the Syndafy Platform that is offensive and/or harmful, including, but not
                            limited to, content that advocates, endorses, condones or promotes racism, bigotry, hatred
or physical harm of any kind against any individual or group of individuals;</li>
                            <li>Upload content that provides materials or access to materials that exploit people in an
abusive, violent or sexual manner;</li>
                            <li>Use the Syndafy Platform to solicit for any other business, website or service, or otherwise
                            contact Users for employment, contracting or any purpose not related to use of the Syndafy
Platform as set forth herein;</li>
                            <li>Use the Syndafy Platform to collect usernames, email addresses, or other personal
information of Users by electronic or other means;</li>
                            <li>Use the Syndafy Platform in a manner that is false or misleading (directly or by omission
                            or failure to update information) or for the purpose of accessing or otherwise obtaining
Company’s trade secret information for public disclosure or other purposes;</li>
                            <li>Attempt to circumvent the payments system or service fees in any way including, but not
                            limited to, processing payments outside of the Syndafy Platform, providing inaccurate
information on invoices, or otherwise invoicing in a fraudulent manner;</li>
                            <li>Register under different usernames or identities after your account has been suspended or
                            terminated, or register under multiple usernames or false identities, or register using a false
or disposable email or phone number;</li>
                            <li>Use the Syndafy Platform or the Service services in violation of this Agreement; or</li>
                            <li>Cause any third party to engage in the restricted activities above.</li>
                        </ul>
                        <br />
                        <br />
  You understand that all submissions made to Public Areas will be public and that you will be
publicly identified by your name or login identification when communicating in Public Areas.
Syndafy will not be responsible for the action of any Users with respect to any information or
materials posted in Public Areas.
                    </div>


                    <div className="small-heading" ref={this[`section_6`]}>
                        7. Mobile App Updates and Upgrades
                    </div>
                    <div className="item-text">
                        By installing one of the Apps, you consent to the installation of the App and any updates or
                        upgrades that are released through the Syndafy Platform. The App (including any updates or
                        upgrades) may (i) cause your device to automatically communicate with Syndafy’s servers to
                        deliver the App functionality and to record usage metrics, (ii) affect App-related preferences or
                        data stored your device, and (iii) collect personal information as set out in our Privacy Policy. You
                        can uninstall the App at any time.
                    </div>



                    <div className="small-heading" ref={this[`section_7`]}>
                        8. Termination and Suspension
                    </div>
                    <div className="item-text">
                        Company may terminate or limit your right to use the Syndafy Platform in the event that we are
investigating or believe that you have breached any provision of this Agreement (a <b>“User
Breach”</b>), by providing you with written or email notice. Such termination or limitation will be
effective immediately upon delivery of such notice.
<br />
                        <br />
If Company terminates or limits your right to use the Syndafy Platform pursuant to this Section 8,
you are prohibited from registering and creating a new account under your name, a fake or
borrowed name, or the name of any third party, even if you may be acting on behalf of the third
party. If Company terminates or limits your right to use the Syndafy Platform as a Client due to a
User Breach, you will not be entitled to any refund of unused balance in your account.
<br />
                        <br />
Even after your right to use the Syndafy Platform is terminated or limited, this Agreement will
remain enforceable against you. Company reserves the right to take appropriate legal action,
including but not limited to pursuing arbitration in accordance with Section 18 of these Terms of
Service.
<br />
                        <br />
Company reserves the right to modify or discontinue, temporarily or permanently, all or any
portion of the Syndafy Platform at its sole discretion. Company is not liable to you for any
modification or discontinuance of all or any portion of the Syndafy Platform. Company has the
right to restrict anyone from completing registration as a Vendor if Company believes such person
may threaten the safety and integrity of the Syndafy Platform, or if, in Company’s discretion, such
restriction is necessary to address any other reasonable business concern.
<br />
                        <br />
You may terminate this Agreement at any time by ceasing all use of the Syndafy Platform. All
parts of this Agreement which by their nature should survive the expiration or termination of this
Agreement shall continue in full force and effect subsequent to and notwithstanding the expiration
or termination of this Agreement.
                    </div>




                    <div className="small-heading" ref={this[`section_8`]}>
                        9. Account, Password, Security, and Mobile Phone Use
                    </div>
                    <div className="item-text">
                        You must register with Company and create an account to use the Syndafy Platform (an
<b>“Account”</b>). You are the sole authorized user of your account. You are responsible for maintaining
the confidentiality of any log-in, password, and account number provided by you or given to you
by Company for accessing the Syndafy Platform. You are solely and fully responsible for all
activities that occur under your password or account, even if not authorized by you. If you are
accessing and using the Syndafy Platform on someone else’s behalf, you represent that you have
the authority to bind that person as the principal to all Terms provided herein. Company has no
control over the use of any User’s account and expressly disclaims any liability derived therefrom.
Should you suspect that any unauthorized party may be using your password or account or you
suspect any other breach of security, you agree to contact Company immediately.
<br />
                        <br />
By providing your mobile phone number and using the Syndafy Platform, you hereby affirmatively
consent to Syndafy’s use of your mobile phone number for calls and recurring texts, (including
with an autodialer and/or prerecorded voice) in order to (a) perform and improve upon the Syndafy
Platform, (b) facilitate the carrying out of Services through the Syndafy Platform, (c) provide you
with information and reminders regarding your registration, orientation, upcoming Services,
product alterations, changes and updates, service outages or alterations. These calls and texts may
include, among other things, reminders about uncompleted or upcoming Services and/or in follow
up to any push notifications delivered through our mobile application. Company will not assess
any charges for calls or texts, but standard message, data or other charges from your wireless
carrier may apply. You may opt-out of receiving texts messages from us by modifying your
account settings on the Site or Apps, texting “STOP” in response to any texts, or by emailing
contact@servicegrace.com and specifying you want to opt-out of texts. You may opt-out of receiving
calls from us by stating that you no longer wish to receive calls during any call with us, or by
emailing contact@servicegrace.com and specifying you want to opt-out of calls. You understand that
we may send you a text confirming any opt-out by you.
                    </div>




                    <div className="small-heading" ref={this[`section_9`]}>
                        10. User Generated Content
                    </div>
                    <div className="item-text">
                        <b>“User Generated Content”</b> is defined as any information and materials you provide to Company,
its corporate partners, or other Users in connection with your registration for and use of the
Syndafy Platform, including without limitation that posted or transmitted for use in Public Areas.
You are solely responsible for User Generated Content, and we act merely as a passive conduit for
your online distribution and publication of your User Generated Content. You acknowledge and
agree that Syndafy is not involved in the creation or development of User Generated Content,
disclaims any responsibility for User Generated Content, and cannot be liable for claims arising
out of or relating to User Generated Content. Further, you acknowledge and agree that Syndafy
has no obligation to monitor, review, or remove User Generated Content, but reserves the right to
limit or remove User Generated Content on the Syndafy Platform at its sole discretion.
<br />
                        <br />
You hereby represent and warrant to Company that your User Generated Content (a) will not be
false, inaccurate, incomplete or misleading; (b) will not be fraudulent or involve the sale of
counterfeit or stolen items; (c) will not infringe on any third party’s copyright, patent, trademark,
trade secret or other proprietary right or rights of publicity, personality or privacy; (d) will not
violate any law, statute, ordinance, or regulation (including without limitation those governing
export control, consumer protection, unfair competition, anti-discrimination, false advertising,
anti-spam or privacy); (e) will not be defamatory, libelous, unlawfully threatening, or unlawfully
harassing; (f) will not be obscene or contain pornography (including but not limited to child
pornography) or be harmful to minors; (g) will not contain any viruses, Trojan Horses, worms,
time bombs, cancelbots or other computer programming routines that are intended to damage,
detrimentally interfere with, surreptitiously intercept or expropriate any system, data or personal
information; (h) will not represent you being employed or directly engaged by or affiliated with
Syndafy or purport you to act as a representative or agent of Syndafy; and (i) will not create liability
for Company or cause Company to lose (in whole or in part) the services of its ISPs or other
partners or suppliers.
<br />
                        <br />
The Syndafy Platform hosts User Generated Content relating to reviews and ratings of specific
Vendors (<b>“Feedback”</b>). Such Feedback is such User’s opinion and not the opinion of Company,
has not been verified or approved by Company and each Client should undertake their own
research to be satisfied that a specific Vendor is the right person for a Service. You agree that
Company is not responsible or liable for any Feedback or other User Generated Content. Company
encourages each User to give objective, constructive and honest Feedback about the other Users
with whom they have transacted. Company is not obligated to investigate any remarks posted by
Users for accuracy or reliability but may do so at its discretion.
<br />
                        <br />
You hereby grant Company a non-exclusive, worldwide, perpetual, irrevocable, royalty-free,
sublicensable (through multiple tiers) right to exercise all copyrights, publicity rights, and any
other rights you have in your User Generated Content, in any media now known or not currently
known in order to perform and improve upon the Syndafy Platform.
<br />
                        <br />
Each Vendor who provides to Company any videotape, film, recording, photograph, voice, or all
related instrumental, musical, or other sound effects (collectively, <b>“Media”</b>), in exchange for the
right to use the Syndafy Platform, hereby waives any and all moral rights in connection with such
Media and irrevocably grants to Company the non-exclusive, fully-paid, royalty-free, transferable,
sublicensable, worldwide, unrestricted, and perpetual right to:
<br />
                        <br />
                        <ul className="unordered">
                            <li>
                                Exhibit, distribute, display, transmit, and broadcast on any and all media, including,
                                without limitation, the internet, any videotape, film, recording or photograph that such User
                                provides to Company or that Company takes of Vendor, and use, reproduce, modify, or
                                creative derivatives of such Vendor picture, silhouette and other reproductions of their
                                physical likeness (as the same may appear in any still camera photograph and/or motion
                                picture film or video) (collectively the “Physical Likeness”);
    </li>
                            <li>
                                Reproduce in all media any recordings of such Vendor’s voice, and all related instrumental,
                                musical, or other sound effects (collectively, the “Voice”), made in connection with the
                                Syndafy Platform;
    </li>
                            <li>
                                Use, and permit to be used, such Vendor’s Physical Likeness and Voice in the advertising,
                                marketing, and/or publicizing of the Syndafy Platform in any media; and
    </li>
                            <li>
                                Use, and permit to be used, such Vendor’s name and identity in connection with the
                                Syndafy Platform.
    </li>
                        </ul>
                        <br />
                        <br />
Each Vendor warrants and represents that they have the lawful authority to grant the rights set out
above.
<br />
                        <br />
Each Vendor hereby waives all rights and releases Syndafy and Affiliates from, and shall neither
sue nor bring any proceeding against any such parties for, any claim or cause of action, whether
now known or unknown, for defamation, invasion of right to privacy, publicity or personality or
any similar matter, or based upon or relating to the use and exploitation of such Vendor’s identity,
likeness or voice in connection with the Syndafy Platform.
<br />
                        <br />
Each Vendor hereby acknowledges that Syndafy may use Vendor’s name and prices publicly and
through the Syndafy Platform.
<br />
                        <br />
Each Vendor acknowledges that Syndafy shall not owe any financial or other remuneration for
using the recordings provided hereunder by such Vendor, either for initial or subsequent
transmission or playback, and further acknowledges that Syndafy is not responsible for any
expense or liability incurred as a result of such Vendor’s recordings or participation in any
recordings, including any loss of such recording data.
                    </div>



                    <div className="small-heading" ref={this[`section_10`]}>
                        11. Links to Third-Party Websites
                    </div>
                    <div className="item-text">
                        The Syndafy Platform may contain links (such as hyperlinks) to third-party websites. Such links
                        do not constitute endorsement by Company or association with those websites, their content or
                        their operators. Such links (including without limitation external websites that are framed by the
                        Syndafy Platform as well as any advertisements displayed in connection therewith) are provided
                        as an information service, for reference and convenience only. Company does not control any such
                        websites, and is not responsible for their (i) availability or accuracy, or (ii) content, advertising,
                        products, or services. It is your responsibility to evaluate the content and usefulness of the
                        information obtained from other websites. You acknowledge and agree that Syndafy is not
                        involved in the creation or development of third-party websites and disclaims any responsibility
                        for third-party websites, and cannot be liable for claims arising out of or relating to third-party
                        websites. Further, you acknowledge and agree that Syndafy has no obligation to monitor, review,
                        or remove links to third-party websites, but reserves the right to limit or remove links to thirdparty
                        websites on the Syndafy Platform at its sole discretion.
<br />
                        <br />
The use of any website controlled, owned or operated by third parties is governed by the terms and
conditions of use and privacy policies for those websites. You access such third-party websites at
your own risk. Syndafy expressly disclaims any liability arising in connection with your use and/or
viewing of any websites or other material associated with links that may appear on the Syndafy
Platform. You hereby agree to hold Syndafy harmless from any liability that may result from the
use of links that may appear on the Syndafy Platform.
<br />
                        <br />
As part of the functionality of the Syndafy Platform, you may link your account with online
accounts you may have with third party service providers (each such account, a <b>“Third-Party
Account”</b>) by either: (i) providing your Third-Party Account login information through the
Syndafy Platform; or (ii) allowing Syndafy to access your Third-Party Account, as is permitted
under the applicable terms and conditions that govern your use of each Third-Party Account. You
represent that you are entitled to disclose your Third-Party Account login information to Syndafy
and/or grant Syndafy access to your Third-Party Account (including, but not limited to, for use for
the purposes described herein), without breach by you of any of the terms and conditions that
govern your use of the applicable Third-Party Account and without obligating Syndafy to pay any
fees or making Syndafy subject to any usage limitations imposed by such third-party service
providers. By granting Syndafy access to any Third-Party Accounts, you understand that (i)
Syndafy may access, make available and store (if applicable) any content that you have provided
to and stored in your Third-Party Account (the <b>“SNS Content”</b>) so that it is available on and
through the Syndafy Platform via your account, including without limitation any friend lists, and
(ii) Syndafy may submit and receive additional information to your Third-Party Account to the
extent you are notified of this when you link your account with the Third-Party Account. Unless
otherwise specified in these Terms of Service, all SNS Content, if any, shall be considered to be
User Generated Content. Depending on the Third-Party Accounts you choose, and subject to the
privacy settings that you have set in such Third-Party Accounts, personally identifiable
information that you post to your Third-Party Accounts may be available on and through your
account on the Syndafy Platform. Please note that if a Third-Party Account or associated service
becomes unavailable or Syndafy’s access to such Third-Party Account is terminated by the thirdparty
service provider, then SNS Content may no longer be available on and through the Syndafy
Platform. You will have the ability to disable the connection between your account on the Syndafy
Platform and your Third-Party Accounts at any time, as set forth below. PLEASE NOTE THAT
YOUR RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED
WITH YOUR THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR
AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE PROVIDERS. Company makes no
effort to review any SNS Content for any purpose, including but not limited to, for accuracy,
legality, or non-infringement, and Company is not responsible for any SNS Content.
                    </div>



                    <div className="small-heading" ref={this[`section_11`]}>
                        12. Worker Classification and Withholdings
                    </div>
                    <div className="item-text">
                        AS SET FORTH IN SECTION 1, SYNDAFY DOES NOT PERFORM SERVICES AND DOES
                        NOT EMPLOY INDIVIDUALS TO PERFORM SERVICES. EACH USER ASSUMES ALL
                        LIABILITY FOR PROPER CLASSIFICATION OF SUCH USER’S WORKERS BASED ON
                        APPLICABLE LEGAL GUIDELINES. IF A CLIENT, YOU INDEMNIFY AND HOLD
                        SYNDAFY AND AFFILIATES HARMLESS, AND IF A VENDOR, YOU FULLY AND
                        FINALLY RELEASE SYNDAFY AND AFFILIATES, FROM ALL LIABILITIES, CLAIMS,
                        CAUSES OF ACTION, DEMANDS, DAMAGES, LOSSES, FINES, PENALTIES OR OTHER
                        COSTS OR EXPENSES THAT VENDORS OR ASSISTANTS MAY INCUR OR BECOME
                        ENTITLED TO, WHETHER UNDER CONTRACT, COMMON LAW, CIVIL LAW, STATUTE
                        OR OTHERWISE, IN RESPECT OF SERVICES OR SERVICE AGREEMENTS OR THE USE
                        OF THE SYNDAFY PLATFORM, INCLUDING WITH RESPECT TO MISCLASSIFICATION
                        OF VENDORS AND ASSISTANTS AND THE TERMINATION OR CESSATION OF ANY
                        SERVICES, SERVICE AGREEMENTS, THIS AGREEMENT OR THE USE OF THE
                        SYNDAFY PLATFORM.
<br />
                        <br />

Users do not have authority to enter into written or oral — whether implied or express — contracts
on behalf of Company. Each User acknowledges and agrees that Syndafy does not, in any way,
supervise, scope, direct, control or monitor a Vendor’s work or Services performed in any manner.
Company does not set a Vendor’s work hours or location of work. Syndafy will not provide any
equipment, tools, labor or materials needed for a particular Service. Syndafy does not provide any
supervision to Users.
<br />
                        <br />

The Syndafy Platform is not an employment agency service or business and Syndafy is not an
employer of any User. As such, Syndafy is not responsible for and will not be liable for workers’
compensation or any tax payments or withholding, including but not limited to applicable sales
taxes, unemployment or employment insurance, social security, disability insurance or any other
applicable federal, provincial or state withholdings in connection with a User’s use of the Syndafy
Platform. Vendors acknowledge and confirm that they are responsible for exercising their own
business judgment in entering into Service Agreements and performing Services and that,
depending on how they exercise such business judgment, there is a chance for individual profit or
loss.
<br />
                        <br />

This Section 12 in no way limits the generality of Section 16.
                    </div>


                    <div className="small-heading" ref={this[`section_12`]}>
                        13. Intellectual Property Rights
                    </div>
                    <div className="item-text">
                        All text, graphics, editorial content, data, formatting, graphs, designs, HTML, look and feel,
                        photographs, music, sounds, images, software, videos, designs, trademarks, logos, typefaces and
other content (collectively <b>“Proprietary Material”</b>) that Users see or read through the Syndafy
Platform is owned by Syndafy, excluding User Generated Content, which Users hereby grant
Syndafy a license to use. Proprietary Material is protected in all forms, media and technologies
now known or hereinafter developed. Syndafy owns all Proprietary Material, as well as the
coordination, selection, arrangement and enhancement of such Proprietary Materials as a
Collective Work under the United States Copyright Act, as amended. The Proprietary Material is
protected by the domestic and international laws governing copyright, patents, and other
proprietary rights. Users may not copy, download, use, redesign, reconfigure, or retransmit
anything from the Syndafy Platform without Syndafy’s express prior written consent and, if
applicable, the holder of the rights to the User Generated Content. Any use of such Proprietary
Material, other than as permitted therein, is expressly prohibited without the prior permission of
Syndafy and, if applicable, the holder of the rights to the User Generated Content.
<br />
                        <br />
The service marks and trademarks of Syndafy, including without limitation Syndafy and Syndafy
logos, are service marks owned by Syndafy. Any other trademarks, service marks, logos and/or
trade names appearing via the Syndafy Platform are the property of their respective owners. You
may not copy or use any of these marks, logos or trade names without the express prior written
consent of the owner.
                    </div>

                    <div className="small-heading" ref={this[`section_13`]}>
                        14. Copyright Complaints and Copyright Agent
                    </div>
                    <div className="item-text">
                        Syndafy respects the intellectual property of others, and expects Users to do the same. If you
                        believe, in good faith, that any materials provided on or in connection with the Syndafy Platform
                        infringe upon your copyright or other intellectual property right, please send the following
                        information to Syndafy’s Copyright Agent at: Syndafy, Inc., 2140 S DUPONT HWY, CAMDEN,
                        DE 19934, USA or contact@servicegrace.com:
<br />
                        <br />
                        <ul className="unordered">
                            <li>A description of the copyrighted work that you claim has been infringed, including the
                            URL (Internet address) or other specific location on the Syndafy Platform where the
                            material you claim is infringed is located. Include enough information to allow Syndafy to
locate the material, and explain why you think an infringement has taken place;</li>
                            <li>A description of the location where the original or an authorized copy of the copyrighted
                            work exists -- for example, the URL (Internet address) where it is posted or the name of
the book in which it has been published;</li>
                            <li>Your address, telephone number, and e-mail address;</li>
                            <li>A statement by you that you have a good faith belief that the disputed use is not authorized
by the copyright owner, its agent, or the law;</li>
                            <li>A statement by you, made under penalty of perjury, that the information in your notice is
                            accurate, and that you are the copyright owner or authorized to act on the copyright owner’s
behalf; and</li>
                            <li>An electronic or physical signature of the owner of the copyright or the person authorized
to act on behalf of the owner of the copyright interest.</li>
                        </ul>
                    </div>

                    <div className="small-heading" ref={this[`section_14`]}>
                        15. Confidential Information
                    </div>
                    <div className="item-text">
                        You acknowledge that Confidential Information (as defined below) is a valuable, special and
                        unique asset of Syndafy and agree that you will not disclose, transfer, use (or seek to induce others
                        to disclose, transfer or use) any Confidential Information for any purpose other than using the
                        Syndafy Platform in accordance with these Terms of Service. If relevant, you may disclose the
                        Confidential Information to your authorized employees and agents provided that they are also
                        bound to maintain the confidentiality of Confidential Information. You shall promptly notify
                        Syndafy in writing of any circumstances that may constitute unauthorized disclosure, transfer, or
                        use of Confidential Information. You shall use best efforts to protect Confidential Information
                        from unauthorized disclosure, transfer or use. You shall return all originals and any copies of any
                        and all materials containing Confidential Information to Syndafy upon termination of this
                        Agreement for any reason whatsoever.
<br />
                        <br />
The term <b>“Confidential Information”</b> shall mean any and all of Syndafy’s trade secrets,
confidential and proprietary information, and all other information and data of Syndafy that is not
generally known to the public or other third parties who could derive value, economic or otherwise,
from its use or disclosure. Confidential Information shall be deemed to include technical data,
know-how, research, product plans, products, services, customers, markets, software,
developments, inventions, processes, formulas, technology, designs, drawings, engineering,
hardware configuration information, marketing, finances, strategic and other proprietary and
confidential information relating to Syndafy or Syndafy’s business, operations or properties,
including information about Syndafy’s staff, Users or partners, or other business information
disclosed directly or indirectly in writing, orally or by drawings or observation.
                    </div>

                    <div className="small-heading" ref={this[`section_15`]}>
                        16. Disclaimer of Warranties
                    </div>
                    <div className="item-text">
                        &nbsp;&nbsp;&nbsp;&nbsp;<b>(a) Use of the Syndafy Platform is Entirely at Your Own Risk</b>
                        <br />
                        <br />
                        <div className="alphabetic-bullet">
                            THE SYNDAFY PLATFORM IS PROVIDED ON AN “AS IS” BASIS WITHOUT
                            WARRANTIES OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED,
                            INCLUDING, BUT NOT LIMITED TO, WARRANTIES OR CONDITIONS OF
                            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.
                            SYNDAFY MAKES NO WARRANTIES OR REPRESENTATIONS
                            ABOUT THE ACCURACY OR COMPLETENESS OF THE CONTENT PROVIDED
                            THROUGH THE SYNDAFY PLATFORM OR THE CONTENT OF ANY SITES
                            LINKED TO THE SYNDAFY PLATFORM AND ASSUMES NO LIABILITY OR
                            RESPONSIBILITY IN CONTRACT, WARRANTY OR IN TORT FOR ANY (I)
                            ERRORS, MISTAKES, OR INACCURACIES OF CONTENT, (II) PERSONAL INJURY
                            OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM
                            YOUR ACCESS TO AND USE OF THE SYNDAFY PLATFORM, (III) ANY ACCESS
                            TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL
                            INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN; AND
                            (IV) EVENTS BEYOND OUR REASONABLE CONTROL.
<br />
                            <br />
Syndafy does not warrant, endorse, guarantee or assume responsibility for any service
advertised or offered by a third party through the Syndafy Platform or any hyperlinked
website or featured in any banner or other advertising, and Syndafy will not be a party to
or in any way be responsible for monitoring any transaction between you and third-party
providers of products or services. As with the purchase of a product or service through any
medium or in any environment, you should use your best judgment and exercise caution
where appropriate. Without limiting the foregoing, Syndafy and Affiliates do not warrant
that access to the Syndafy Platform will be uninterrupted or that the Syndafy Platform will
be error-free; nor do they make any warranty as to the results that may be obtained from
the use of the Syndafy Platform, or as to the timeliness, accuracy, reliability, completeness
or content of any Service, service, information or materials provided through or in
connection with the use of the Syndafy Platform. Syndafy and Affiliates are not responsible
for the conduct, whether online or offline, of any User. Syndafy and Affiliates do not
warrant that the Syndafy Platform is free from computer viruses, system failures, worms,
trojan horses, or other harmful components or malfunctions, including during hyperlink to
or from third-party websites. Syndafy and Affiliates cannot and do not guarantee that any
personal information supplied by you will not be misappropriated, intercepted, deleted,
destroyed or used by others.
<br />
                            <br />
Notwithstanding any feature a Client may use to expedite Syndafy selection, each Client
is responsible for determining the Service and selecting their Vendor and Syndafy does not
warrant any goods or services purchased by a Client and does not recommend any
particular Vendor. Syndafy does not provide any warranties or guarantees regarding any
Vendor’s professional accreditation, registration or license.
<br />
                            <br />
In addition, no individual or entity shall be a third-party beneficiary of these terms. These
terms are solely for the benefit of the parties to this Agreement and are not intended to and
shall not be construed to give any person or entity other than you any interest, remedy,
claim, liability, reimbursement, claim of action or any other rights (including, without
limitation, any third party beneficiary rights), with respect to or in connection with any
agreement or provision contained herein or contemplated hereby.
<br />
                            <br />
As a Vendor, you acknowledge that a Client may accept your bid, but may not follow
through with the transaction. Syndafy does not warrant, endorse, guarantee or assume
responsibility for any action not performed by Client.
</div>
                        <br />
                        <br />

&nbsp;&nbsp;&nbsp;&nbsp;<b>(b) No Liability</b>
                        <br />
                        <br />
                        <div className="alphabetic-bullet">
                            You acknowledge and agree that Syndafy is only willing to provide the Syndafy Platform
                            if you agree to certain limitations of our liability to you and third parties. Therefore, you
                            agree not to hold Syndafy and Affiliates, or their corporate partners, liable for any claims,
                            demands, damages, expenses, losses, governmental obligations, suits, and/or controversies
                            of every kind and nature, known and unknown, suspected and unsuspected, disclosed and
                            undisclosed, direct, indirect, incidental, actual, consequential, economic, special, or
                            exemplary, including attorneys fees and costs (collectively, “Liabilities”) that have arisen
                            or may arise, relating to your or any other party’s use of or inability to use the Syndafy
                            Platform, including without limitation any Liabilities arising in connection with the
                            conduct, act or omission of any User (including without limitation stalking, harassment
                            that is sexual or otherwise, acts of physical violence, and destruction of personal property),
                            any dispute with any User, any instruction, advice, act, or service provided by Syndafy and
                            Affiliates and any destruction of your User Generated Content.
<br />
                            <br />
YOU UNDERSTAND AND AGREE THAT SYNDAFY HAS NO CONTROL OVER
THE CONDUCT OF THE VENDOR OR CLIENT.
<br />
                            <br />
UNDER NO CIRCUMSTANCES WILL SYNDAFY AND AFFILIATES OR THEIR
CORPORATE PARTNERS BE LIABLE FOR ANY DIRECT, INDIRECT,
INCIDENTAL, ACTUAL, CONSEQUENTIAL, ECONOMIC, SPECIAL OR
EXEMPLARY DAMAGES (INCLUDING BUT NOT LIMITED TO LOST PROFITS,
LOSS OF DATA, LOSS OF GOODWILL, SERVICE INTERRUPTION, COMPUTER
DAMAGE, SYSTEM FAILURE, FAILURE TO STORE ANY INFORMATION OR
OTHER CONTENT MAINTAINED OR TRANSMITTED BY SYNDAFY, OR THE
COST OF SUBSTITUTE PRODUCTS OR SERVICES) ARISING IN CONNECTION
WITH YOUR USE OF OR INABILITY TO USE THE SYNDAFY PLATFORM OR THE
SERVICE SERVICES, EVEN IF ADVISED OF THE POSSIBILITY OF THE SAME.
SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATIONS
MAY NOT APPLY TO YOU IN THEIR ENTIRETY.
<br />
                            <br />
SYNDAFY AND AFFILIATES EXPRESSLY DISCLAIM ANY LIABILITY THAT
MAY ARISE BETWEEN USERS OF ITS SYNDAFY PLATFORM. SYNDAFY AND
AFFILIATES ALSO DO NOT ACCEPT ANY LIABILITY WITH RESPECT TO THE
QUALITY OR FITNESS OF ANY WORK PERFORMED VIA THE SYNDAFY
PLATFORM.
<br />
                            <br />
IF, NOTWITHSTANDING THE FOREGOING EXCLUSIONS, IT IS DETERMINED
THAT SYNDAFY AND AFFILIATES OR THEIR CORPORATE PARTNERS ARE
LIABLE FOR DAMAGES, IN NO EVENT WILL THE AGGREGATE LIABILITY,
WHETHER ARISING IN CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE,
EXCEED THE TOTAL FEES PAID BY YOU TO COMPANY DURING THE SIX (6)
MONTHS PRIOR TO THE TIME SUCH CLAIM AROSE, TO THE EXTENT
PERMITTED BY APPLICABLE LAW.
<br />
                            <br />
Some jurisdictions do not allow the exclusion of certain warranties or limitation of liability
for consequential or incidental damages, so certain aspects of the limitations above may
not apply to you and shall not limit or exclude liability for any liability that cannot be
excluded by applicable law.
</div>
                        <br />
                        <br />
  &nbsp;&nbsp;&nbsp;&nbsp;<b>(c) Release</b>
                        <br />
                        <br />
                        <div className="alphabetic-bullet">
                            THE SYNDAFY PLATFORM IS ONLY A VENUE FOR CONNECTING USERS.
                            BECAUSE SYNDAFY IS NOT A PARTY TO OR OTHERWISE INVOLVED IN THE
                            ACTUAL CONTRACT BETWEEN USERS OR IN THE COMPLETION OF THE
                            SERVICE, IN THE EVENT THAT YOU HAVE A DISPUTE WITH ONE OR MORE
                            USERS, YOU HEREBY RELEASE SYNDAFY AND AFFILIATES AND THEIR
                            CORPORATE PARTNERS FROM ANY AND ALL CLAIMS, DEMANDS, DAMAGES
                            (INCLUDING DIRECT, INDIRECT, INCIDENTAL, ACTUAL, CONSEQUENTIAL,
                            ECONOMIC, SPECIAL, OR EXEMPLARY), EXPENSES, LOSSES,
                            GOVERNMENTAL OBLIGATIONS, SUITS AND/OR CONTROVERSIES OF EVERY
                            KIND AND NATURE, KNOWN AND UNKNOWN, SUSPECTED AND
                            UNSUSPECTED, DISCLOSED AND UNDISCLOSED, ARISING OUT OF OR IN ANY
                            WAY CONNECTED WITH SUCH DISPUTE.
<br />
                            <br />
TO THE EXTENT APPLICABLE, YOU HEREBY WAIVE THE PROTECTIONS OF
CALIFORNIA CIVIL CODE § 1542 (AND ANY ANALOGOUS LAW IN ANY OTHER
APPLICABLE JURISDICTION) WHICH READS AS FOLLOWS: “A GENERAL
RELEASE DOES NOT EXTEND TO CLAIMS THAT THE CREDITOR OR
RELEASING PARTY DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER
FAVOR AT THE TIME OF EXECUTING THE RELEASE AND THAT, IF KNOWN
BY HIM OR HER, WOULD HAVE MATERIALLY AFFECTED HIS OR HER
SETTLEMENT WITH THE DEBTOR OR RELEASED PARTY.”</div>
                    </div>

                    <div className="small-heading" ref={this[`section_16`]}>
                        17. Indemnification
                    </div>
                    <div className="item-text">
                        You hereby agree to indemnify, defend, and hold harmless Syndafy and Affiliates, and their
attorneys, insurers, independent contractors, providers, successors and assigns (the <b>“Indemnified
Parties”</b>) from and against any and all Liabilities incurred in connection with (i) your use or
inability to use the Syndafy Platform or perform Services, or (ii) your breach or violation of this
Agreement; (iii) your violation of any law, or the rights of any User or third party and (iv) any
content submitted by you or using your account to the Syndafy Platform, including, but not limited
to the extent such content may infringe on the intellectual rights of a third party or otherwise be
illegal or unlawful. You also agree to indemnify the Indemnified Parties for any Liabilities
resulting from your use of software robots, spiders, crawlers, or similar data gathering and
extraction tools, or any other action you take that imposes an unreasonable burden or loan on our
infrastructure. Syndafy reserves the right, in its own sole discretion, to assume the exclusive
defense and control at its own expense of any matter otherwise subject to your indemnification.
You will not, in any event, settle any claim or matter without the prior written consent of Syndafy.
                    </div>

                    <div className="small-heading" ref={this[`section_17`]}>
                        18. Dispute Resolution – Arbitration & Class Action Waiver (U.S. Users)
                    </div>
                    <div className="item-text">
                        <i style={{ backgroundColor: '#ffff006e', fontWeight: 'bold' }}>USERS RESIDING IN THE UNITED STATES:</i> PLEASE READ THIS SECTION
CAREFULLY — IT AFFECTS YOUR LEGAL RIGHTS AND GOVERNS HOW YOU AND
SYNDAFY CAN BRING CLAIMS AGAINST EACH OTHER. THIS SECTION WILL, WITH
LIMITED EXCEPTION, REQUIRE YOU AND SYNDAFY TO SUBMIT CLAIMS AGAINST
EACH OTHER TO BINDING AND FINAL ARBITRATION ON AN INDIVIDUAL BASIS.
<br />
                        <br />
  &nbsp;&nbsp;<b>(a) Informal Negotiations</b>
                        <br />
                        <br />
                        <div className="alphabetic-bullet">
                            To expedite resolution and reduce the cost of any dispute, controversy or claim between you
and Syndafy (each a <b>“Claim”</b> and collectively <b>“Claims”</b>), you and Syndafy agree to first
attempt to negotiate any Claim (except those Claims expressly excluded below) informally
for at least thirty (30) days before initiating any arbitration. This pre-arbitration negotiation
shall be initiated by providing written notice to the other party—including a brief written
statement describing the name, address, and contact information of the notifying party, the
facts giving rise to the Claim, and the relief requested. You must send such written notice to
Syndafy, Inc., 2140 S DUPONT HWY, CAMDEN, DE 19934, USA. If necessary to preserve
a Claim under any applicable statute of limitations, you or Syndafy may initiate arbitration
while engaging in the informal negotiations.
<br />
                            <br />
During this pre-arbitration negotiation, all offers, promises, conduct and statements, whether
oral or written, made in the course of the negotiation by any of the parties, their agents,
employees, and attorneys are confidential, privileged and inadmissible for any purpose,
including as evidence of liability, in arbitration or other proceeding involving the parties.
<br />
                            <br />
After a good faith effort to negotiate, if you or Syndafy believe a Claim cannot be resolved
informally, the party intending to pursue arbitration agrees to notify the other party via email
prior to initiating the arbitration. In order to initiate arbitration, a claim must be filed with the
American Arbitration Association (<b>“AAA”</b>) and the written Demand for Arbitration
(available at www.adr.org) must be provided to the other party, as specified in the Commercial
Arbitration Rules (the <b>“AAA Rules”</b>).
</div>
                        <br />
                        <br />
  &nbsp;&nbsp;<b>(b) Agreement to Binding Arbitration</b>
                        <br />
                        <br />
                        <div className="alphabetic-bullet">
                            IN EXCHANGE FOR THE BENEFITS OF THE SPEEDY, ECONOMICAL, AND
                            IMPARTIAL DISPUTE RESOLUTION PROCEDURE OF ARBITRATION, YOU AND
                            SYNDAFY MUTUALLY AGREE TO WAIVE YOUR RESPECTIVE RIGHTS TO
                            RESOLUTION OF ALL CLAIMS BETWEEN YOU (EXCEPT THOSE EXPRESSLY
                            EXCLUDED BELOW) IN A COURT OF LAW BY A JUDGE OR JURY AND AGREE TO
                            RESOLVE ANY DISPUTES BY BINDING ARBITRATION ON AN INDIVIDUAL BASIS
                            AS SET FORTH HEREIN.
<br />
                            <br />
This agreement to arbitrate contained in this Section 18 (<b>“Arbitration Agreement”</b>) is
governed by the Federal Arbitration Act and survives the termination of this Agreement and
your relationship with Company.
<br />
                            <br />
Claims covered by this Arbitration Agreement include, but are not limited to, any dispute,
claim or controversy whether based on past, present or future events arising out of or relating
to: this Agreement and prior versions (including the breach, termination, enforcement,
interpretation or validity thereof); the Syndafy Platform, services, or Services; your
relationship with Syndafy; the threatened or actual suspension, deactivation or termination of
your Account or this Agreement; payments made by you or any payments made or allegedly
owed to you; any city, county, state or federal wage-hour law; compensation, breaks and rests
periods, expense reimbursement, wrongful termination, discrimination, harassment,
retaliation, fraud, defamation, trade secrets, unfair competition, emotional distress; any
promotions or offers made by Company; breach of any express or implied contract or breach
of any express or implied covenant; claims arising under federal or state consumer protection
laws; claims arising under antitrust laws; claims arising under the Telephone Consumer
Protection Act and Fair Credit Reporting Act; and claims arising under the Fair Labor
Standards Act, Civil Rights Act of 1964, Uniform Trade Secrets Act, Americans With
Disabilities Act, Age Discrimination in Employment Act, Older Workers Benefit Protection
Act, Family Medical Leave Act, Employee Retirement Income Security Act (except for
individual claims for employee benefits under any benefit plan sponsored by Company and
covered by the Employee Retirement Income Security Act of 1974 or funded by insurance),
and state statutes, if any, addressing the same or similar subject matters; and all other federal
and state statutory and common law claims.
<br />
                            <br />
If there is a dispute about the arbitrability of any Claim (including questions about the scope,
applicability, interpretation, validity, and enforceability of this arbitration agreement), you
and Syndafy agree that this threshold dispute shall be delegated to the arbitrator (not a court)
and that the arbitrator shall have initial authority to resolve such threshold disputes, except as
expressly provided below.
<br />
                            <br />
YOU ACKNOWLEDGE AND UNDERSTAND THAT YOU AND SYNDAFY ARE
WAIVING THE RIGHT TO SUE IN COURT OR HAVE A JURY TRIAL FOR ALL
CLAIMS, UNLESS EXPRESSLY EXCLUDED IN THIS ARBITRATION AGREEMENT.
THIS ARBITRATION AGREEMENT IS INTENDED TO REQUIRE ARBITRATION OF
EVERY CLAIM OR DISPUTE THAT CAN LAWFULLY BE ARBITRATED, EXCEPT
THOSE CLAIMS AND DISPUTES WHICH BY THE TERMS OF THIS ARBITRATION
AGREEMENT ARE EXPRESSLY EXCLUDED FROM THE REQUIREMENT TO
ARBITRATE.
</div>
                        <br />
                        <br />
  &nbsp;&nbsp;<b>(c) Agreement Prohibiting Class Actions and Non-Individualized Relief</b>
                        <br />
                        <br />
                        <div className="alphabetic-bullet">
                            Except as otherwise required under applicable law, you and Syndafy agree that any arbitration
                            will be limited to the Claim between Syndafy and you individually. YOU ACKNOWLEDGE
                            AND AGREE THAT YOU AND SYNDAFY ARE EACH WAIVING THE RIGHT TO
                            PARTICIPATE AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS
                            ACTION LAWSUIT, CLASS-WIDE ARBITRATION, OR ANY OTHER
REPRESENTATIVE PROCEEDING (<b>“Class Action Waiver”</b>). Further, unless both you
and Syndafy otherwise agree, the arbitrator may not consolidate more than one person’s
claims, and may not otherwise preside over any form of any class or representative
proceeding. The arbitrator shall have no authority to consider or resolve any Claim or issue
any relief on any basis other than an individual basis. The arbitrator shall have no authority to
consider or resolve any Claim or issue any relief on a class, collective, or representative basis.
<br />
                            <br />
Notwithstanding any other provision of this Agreement, the Arbitration Agreement or the
AAA Rules (as defined below), disputes regarding the scope, applicability, enforceability,
revocability or validity of the Class Action Waiver may be resolved only by a civil court of
competent jurisdiction and not by an arbitrator. In any case in which: (i) the Claim is filed as
a class, collective, or representative action and (ii) there is a final judicial determination that
the Class Action Waiver is unenforceable as to any Claims, then those Claims shall be severed
from any remaining Claims and may remain in a civil court of competent jurisdiction, but the
Class Action Waiver shall be enforced in arbitration on an individual basis as to all other
Claims to the fullest extent possible.
</div>
                        <br />
                        <br />
  &nbsp;&nbsp;<b>(d) Rules and Logistics Governing Arbitration</b>
                        <br />
                        <br />
                        <div className="alphabetic-bullet">
                            The arbitration will be commenced and conducted under the AAA Rules in effect at the time
                            the arbitration is initiated and modified by the terms set forth in this Agreement, and, where
appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes (<b>“AAA
Consumer Rules”</b>), both of which are available at the AAA website www.adr.org or by
calling the AAA at 1-800-778-7879. Notwithstanding the foregoing, if requested by you and
if proper based on the facts and circumstances of the Claims presented, the arbitrator shall
have the discretion to select a different set of AAA Rules, but in no event shall the arbitrator
consolidate more than one person’s Claims, or otherwise preside over any form of
representative, collective, or class proceeding. You and Syndafy agree that the arbitration
shall be administered before a single arbitrator mutually agreed upon by the parties, and if the
parties cannot agree within thirty (30) days after names of potential arbitrators have been
proposed, then by a single arbitrator who is chosen by the AAA.
<br />
                            <br />
As part of the arbitration, both you and Company will have the opportunity for reasonable
discovery of non-privileged information that is relevant to the Claim(s). The arbitrator may
award any individualized remedies that would be available in court. The arbitrator may award
declaratory or injunctive relief only in favor of the individual party seeking relief and only to
the extent necessary to provide relief warranted by that party’s individual claims. The
arbitrator will provide a reasoned written statement of the arbitrator’s decision, which shall
explain the award given and the findings and conclusions on which the decision is based.
<br />
                            <br />
The arbitrator will decide the substance of all Claims in accordance with applicable law, and
will honor all claims of privilege recognized by law. The arbitrator’s award shall be final and
binding and judgment on the award rendered by the arbitrator may be entered in any court
having jurisdiction thereof.
<br />
                            <br />
Your arbitration fees and your share of arbitrator compensation will be governed by the AAA
Rules (and, where appropriate, limited by the AAA Consumer Rules) subject to the following
modifications:
<br />
                            <br />
(i) If Company initiates arbitration under this Arbitration Agreement, Company will pay all
AAA filing and arbitration fees.
<br />
                            <br />
(ii) If a Client or Vendor files a Claim in accordance with this Arbitration Agreement and the
associated claim for damages does not exceed USD $10,000, Company will pay all AAA
filing and arbitration fees unless the arbitrator finds that either the substance of your claim or
the relief sought in your Demand for Arbitration was frivolous or was brought for an improper
purpose (as measured by the standards set forth in Federal Rule of Civil Procedure 11(b)).
<br />
                            <br />
(iii) If a Client or Vendor files a Claim in accordance with this Arbitration Agreement and the
associated claim for damages exceeds USD $10,000, Company shall pay all costs unique to
arbitration (as compared to the costs of adjudicating the same claims before a court), including
the regular and customary arbitration fees and expenses, and the Client or Vendor shall be
responsible for contributing up to an amount equal to the filing fee that would be paid to
initiate the claim in the court of general jurisdiction in the state in which they perform
Services, unless a lower fee amount would be owed by you as required by law or the
applicable AAA Rules. Any dispute as to whether a cost is unique to arbitration shall be
resolved by the arbitrator. If the arbitrator finds that the substance of your claim or the relief
sought is frivolous or brought for an improper purpose, however, then the allocation of fees
will be governed by the applicable AAA Rules.
<br />
                            <br />
(iv) Except as required by law or the applicable AAA Rules, each party shall pay its own
attorneys’ fees and pay any costs that are not unique to the arbitration (i.e., costs that each
party would incur if the Claim(s) were litigated in a court, such as costs to subpoena witnesses
and/or documents, take depositions and purchase deposition transcripts, copy documents,
etc.).
<br />
                            <br />
(v) At the conclusion of any arbitration, the arbitrator may award reasonable fees and costs or
any portion thereof to the prevailing party, to the extent authorized by applicable law or the
applicable AAA Rules.
<br />
                            <br />
Unless you and Company agree otherwise, any arbitration hearings between Company and a
Vendor will take place in the county of your billing address, and any arbitration hearings
between Company and a Client will take place in the county in which you received Service
services. If AAA arbitration is unavailable in your county, the arbitration hearings will take
place in the nearest available location for a AAA arbitration.
</div>
                        <br />
                        <br />
  &nbsp;&nbsp;<b>(e) Exceptions to Arbitration</b>
                        <div className="alphabetic-bullet">
                            <br />
                            <br />
  The following types of Claims may be, but are not required to be, arbitrated under the
Arbitration Agreement:
<br />
                            <br />
                            <ul className="unordered">
                                <li>Claims for workers’ compensation, disability insurance and unemployment insurance
benefits;</li>
                                <li>Small claims actions that are within the scope of small claims court jurisdiction and brought
on an individual basis;</li>
                                <li>Applications for provisional remedies, preliminary injunctions, and temporary restraining
                                orders, including those relating to actual or threatened infringement, misappropriation, or
                                violation of a party’s copyrights, trademarks, trade secrets, patents, or other intellectual
property rights; and</li>
                                <li>Claims that may not be subject to arbitration as a matter of general law not preempted by
the Federal Arbitration Act.</li>
                            </ul>
                            <br />
                            <br />
  Nothing in this Arbitration Agreement prevents you from making a report to or filing a claim
or charge with the Equal Employment Opportunity Commission, U.S. Department of Labor,
Securities Exchange Commission, National Labor Relations Board, or Office of Federal
Contract Compliance Programs, or similar local, state or federal agency, and nothing in this
Arbitration Agreement shall be deemed to preclude or excuse a party from bringing an
administrative claim before any agency in order to fulfill the party’s obligation to exhaust
administrative remedies before making a claim in arbitration. However, you knowingly and
voluntarily waive the right to seek or recover money damages of any type pursuant to any
administrative complaint and instead may seek such relief only through arbitration under this
Agreement. This Agreement and Arbitration Agreement do not prevent you from participating
in an investigation by a government agency of any report, claim or charge otherwise covered
by this Arbitration Agreement and do not prevent you from receiving an award for information
provided to any government agencies.
  </div>

                        <br />
                        <br />
  &nbsp;&nbsp;<b>(f) Severability</b>
                        <br />
                        <br />
                        <div className="alphabetic-bullet">Except as otherwise provided in the severability provisions in Sections 18(c) above, in the
                        event that any portion of this Arbitration Agreement is deemed illegal or unenforceable, such
                        provision shall be severed and the remainder of the Arbitration Agreement shall be given full
force and effect.</div>
                        <br />
                        <br />
  &nbsp;&nbsp;<b>(g) Right to Opt Out of Arbitration Agreement</b>
                        <br />
                        <br />
                        <div className="alphabetic-bullet">If you are a Vendor, you may opt out of the Arbitration Agreement by notifying Company in
                        writing within three (3) days of your agreement to these Terms of Service. To opt out, you
                        must send a written notification to Company at Syndafy, Inc., 2140 S DUPONT HWY,
                        CAMDEN, DE 19934, USA, that includes (a) your account username, (b) your name, (c) your
                        address, (d) your telephone number, (e) your email address, and (f) a clear statement
                        indicating that you do not wish to resolve claims through arbitration and demonstrating
                        compliance with the 3-day time limit to opt out of the above arbitration and class action/jury
                        trial waiver provisions.
</div>
                    </div>

                    <div className="small-heading" ref={this[`section_18`]}>
                        19. Governing Law
                    </div>
                    <div className="item-text">
                        Except as provided in Section 18 or expressly provided otherwise, this Agreement and your use of
                        the Syndafy Platform will be governed by, and will be construed under, the laws of the State of
                        Delaware, without regard to choice of law principles. This choice of law provision is only intended
                        to specify the use of Delaware law to interpret this Agreement and is not intended to create any
                        substantive right to non-Delawareans to assert claims under Delaware law whether by statute,
                        common law, or otherwise.
                    </div>

                    <div className="small-heading" ref={this[`section_19`]}>
                        20. No Agency; No Employment
                    </div>
                    <div className="item-text">
                        No agency, partnership, joint venture, employer-employee or franchiser-franchisee relationship is
                        intended or created by this Agreement.
                    </div>

                    <div className="small-heading" ref={this[`section_20`]}>
                        21. General Provisions
                    </div>
                    <div className="item-text">
                        Failure by Company to enforce any provision(s) of this Agreement will not be construed as a
                        waiver of any provision or right. This Agreement constitutes the complete and exclusive agreement
                        between you and Company with respect to its subject matter, and supersedes and governs any and
                        all prior agreements or communications. The provisions of this Agreement are intended to be
                        interpreted in a manner which makes them valid, legal, and enforceable. Except for the
                        “Agreement Prohibiting Class Actions and Non-Individualized Relief” in Section 18, in the event
                        any provision is found to be partially or wholly invalid, illegal or unenforceable, (1) such provision
                        shall be modified or restructured to the extent and in the manner necessary to render it valid, legal,
                        and enforceable or, (2) if such provision cannot be so modified or restructured, it shall be excised
                        from the Agreement without affecting the validity, legality or enforceability of any of the
                        remaining provisions. This Agreement may not be assigned or transferred by you without our prior
                        written approval. We may assign or transfer this Agreement without your consent, including but
                        not limited to assignments: (i) to a parent or subsidiary, (ii) to an acquirer of assets, or (iii) to any
                        other successor or acquirer. Any assignment in violation of this Section 21 shall be null and void.
                        This Agreement will inure to the benefit of Company, its successors and assigns.
                    </div>

                    <div className="small-heading" ref={this[`section_21`]}>
                        22. Licensing
                    </div>
                    <div className="item-text">
                        Vendors alone are responsible for identifying and obtaining any required licenses, permits, or
                        registrations before offering services and undertaking Services. Indeed, certain types of Services
                        may be prohibited altogether, and it is the responsibility of Vendors to avoid such prohibited
                        Services. Penalties may include fines or other enforcement. If you have questions about how local
                        laws apply to your Services on the platform, you can and should first seek separate legal guidance.
<br />
                        <br />
Because Syndafy does not oversee, monitor or supervise the posting, scoping or performance of
Services, Clients must determine for themselves whether a Vendor is qualified to perform the
specific Service at hand. Clients may wish to consult their state/provincial/territorial or local
requirements to determine whether certain Services are required to be performed by a licensed
professional.
                    </div>

                    <div className="small-heading" ref={this[`section_22`]}>
                        23. Changes to this Agreement and the Syndafy Platform
                    </div>
                    <div className="item-text">
                        Company reserves the right, at its sole and absolute discretion, to change, modify, add to,
                        supplement, suspend, discontinue, or delete any of the terms and conditions of this Agreement
                        (including the Terms of Service and Privacy Policy) and review, improve, modify or discontinue,
                        temporarily or permanently, the Syndafy Platform or any content or information through the
                        Syndafy Platform at any time, effective with or without prior notice and without any liability to
                        Company. Company will endeavor to notify you of material changes by email, but will not be
                        liable for any failure to do so. If any future changes to this Agreement are unacceptable to you or
                        cause you to no longer be in compliance with this Agreement, you must terminate, and
                        immediately stop using, the Syndafy Platform. Your continued use of the Syndafy Platform
                        following any revision to this Agreement constitutes your complete and irrevocable acceptance of
                        any and all such changes. Company may also impose limits on certain features or restrict your
                        access to part or all of the Syndafy Platform without notice or liability.
                    </div>

                    <div className="small-heading" ref={this[`section_23`]}>
                        24. No Rights of Third Parties
                    </div>
                    <div className="item-text">
                        None of the terms of this Agreement are enforceable by any persons who are not a party to this
                        Agreement.
                    </div>

                    <div className="small-heading" ref={this[`section_24`]}>
                        25. Notices and Consent to Receive Notices Electronically
                    </div>
                    <div className="item-text">
                        You consent to receive any agreements, notices, disclosures and other communications
(collectively, <b>“Notices”</b>) to which this Agreement refers electronically including without
limitation by e-mail or by posting Notices on this Site. You agree that all Notices that we provide
to you electronically satisfy any legal requirement that such communications be in writing. Unless
otherwise specified in this Agreement, all notices under this Agreement will be in writing and will
be deemed to have been duly given when received, if personally delivered or sent by certified or
registered mail, return receipt requested; when receipt is electronically confirmed, if transmitted
by facsimile or email; or the day after it is sent, if sent for next day delivery by a recognized
overnight delivery service.
<br />
                        <br />
If you have any questions about these Terms of Service or about the Syndafy Platform, please
contact us by email at contact@servicegrace.com or by mail to 2140 S DUPONT HWY, CAMDEN,
DE 19934, USA.
<br />
                        <br />
I HEREBY ACKNOWLEDGE THAT I HAVE READ AND UNDERSTAND THE
FOREGOING TERMS OF SERVICE AND THE PRIVACY POLICY, AND AGREE THAT MY
USE OF THE SYNDAFY PLATFORM IS AN ACKNOWLEDGMENT OF MY AGREEMENT
TO BE BOUND BY THE TERMS AND CONDITIONS OF THIS AGREEMENT.
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps({ buyer }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        buyerFormData: buyer

    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({

        
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsOfUseContainer);
